<template>
    <Modal :show="isModalVisible"  @close="closeMessages">
        <div class="messages">
            <div class="messages-header">
                <i class="material-icons">message</i>
                <span class="page-title">
                    ID {{page.id}} - {{page.title}}
                </span>
                <div class="messages-header-options">
                    <a href="#" @click.prevent="openFilter">
                        <i class="material-icons">search</i>
                    </a>
                    <a href="#" @click.prevent="closeMessages">
                        <i class="material-icons">close</i>
                    </a>
                </div>
            </div>
            <div class="messages-body">
                <div class="messages-filter" v-if="isFilterVisible">
                    <label class="sr-only" for="filter">Escribe aquí para buscar</label>
                    <div class="input-group">
                        <input type="text" id="filter" v-model="filter" class="form-control" placeholder="Escribe aquí para buscar"/>
                        <div class="input-group-btn">
                            <button class="btn btn-primary" type="button">
                                <i class="material-icons">search</i>
                            </button>
                        </div>
                    </div>
                </div>
                <message-list :messages="messagesFiltered()" :owner="owner" />
            </div>
            <div class="messages-footer">
                <label class="sr-only" for="text">Escribe aquí el mensaje que quieres enviar</label>
                <div class="input-group">
                    <input type="text" id="text" v-model="text" class="form-control" placeholder="Escribe aquí el mensaje que quieres enviar"/>
                    <div class="input-group-btn">
                        <button class="btn btn-primary" type="button" @click="storeMessage">Enviar</button>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>

    import Modal from './Modal.vue';
    import MessageList from './MessageList.vue';

    export default {
        components: {
            Modal,
            MessageList
        },
        props: ['owner'],
        data () {
            return {
                isModalVisible: false,
                isFilterVisible: false,
                id: null,
                page: {},
                text: '',
                filter: ''
            };
        },
        created () {
          this.$eventHub.$on('show-messages', (pageId) => {
              this.openMessages(pageId);
          })
        },
        updated () {
            const body = this.$el.querySelector('.messages-body');
            body.scrollTop = body.scrollHeight;
        },
        beforeDestroy () {
            this.$eventHub.$off('show-messages');
        },
        methods: {
            openMessages (pageId) {
                this.isModalVisible = true;
                this.id = pageId;
                this.findPage();
            },
            closeMessages () {
                this.isModalVisible = false;
                this.id = null;
            },
            openFilter () {
                this.isFilterVisible = true;
            },
            findPage () {
                axios({
                    url: `backend/api/pages/${this.id}`,
                    method: 'GET'
                })
                    .then(response => {
                        this.page = response.data;
                    }).catch(error => {
                        this.errors = error.response.data.errors;
                    });
            },
            storeMessage () {
                axios({
                    url: `backend/api/pages/${this.id}/messages`,
                    method: 'POST',
                    data: {
                        text: this.text
                    }
                })
                    .then(response => {
                        this.page.messages.push(response.data);
                        this.text = '';
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                    });
            },
            messagesFiltered () {
                if (this.filter) {
                    return this.page.messages
                        .filter(message => message.text.includes(this.filter));
                }

                return this.page.messages;
            }
        }
    }

</script>